import { api } from '@api'
import { Scope } from '@utils'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export type ScheduledMessage = {
  id: string
  message: string
  recipientAccountId: string | null
  groupId: string | null
  groupParticipants: { id: string; avatarUrl: string | undefined }[] | null
  scheduledDate: string
  date: string
  time: string
  scope: string
  recipient: {
    name: string
    photo: string | null
  }
  createdAt: string
  updatedAt: string
}

const fetchScheduledMessages = async ({ pageParam = '0', search, scope, moment }: FetchParams): Promise<PaginatedResponse<ScheduledMessage>> => {
  let url = `/scheduled-messages?page=${pageParam}`
  if (search) url += `&search=${search}`
  if (scope) url += `&scope=${scope}`
  if (moment) url += `&moment=${moment}`
  
  const { data } = await api.get<PaginatedResponse<ScheduledMessage>>(url)
  return data
}

export const usePaginateScheduledMessages = ({ search, scope, moment }: { search?: string, scope?: Scope, moment?: 'today' | 'week' | 'month' | 'later' } = {}) => {
  return usePaginate<ScheduledMessage>('scheduled-messages', fetchScheduledMessages, { search, scope, moment })
}

